import React, { Component } from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Navbar from 'react-bootstrap/Navbar'
import NavbarBrand from 'react-bootstrap/NavbarBrand'
import Nav from 'react-bootstrap/Nav'

import Thereturn from './Pages/thereturn.js'
import Sidescroller from './Pages/sidescroller.js'
import Adventure from './Pages/Adventure.js'
import Footer from './Components/Footer.js'
import HomePage from './Pages/HomePage.js'
import ContactPage from './Pages/ContactPage.js'
import AboutPage from './Pages/AboutPage.js'
import Gallery from './Pages/gallery.js'

class App extends Component {
  constructor(props){
  super(props)
  this.state = {
    title: 'Ryan Kidd',
    headerlinks: [
      { title: 'Home', path: '/'},
      { title: 'About', path: '/about'},
      { title: 'Contact', path: '/Contact'},
      { title: 'Adventure', path: '/adventure'},
      { title: 'Gallery', path: '/gallery'},
      { title: 'CoverLetter', path:'/CoverLetter'},
      { title: 'Resume', path: '/Resume'}
      ],
      home:{
        title: '',
        subTitle: 'Level Design Projects',
        text: 'Checkout my projects below'
      },
      about:{
        title: 'About Me',
    },
    contact:{
      title: 'Lets Talk',
    }
  }

}



    render(){
      return(


        <Router basename="/HomePage">
        <Container className="p-0" fluid={true}>

        <Navbar  className ="border-bottom" bg="transparent" expand="lg">
          <NavbarBrand style={{color: 'goldenrod'}}>Ryan Kidd</NavbarBrand>

            <Navbar.Toggle className="border-0" aria-controls="navbar-toggle" />
                  <Navbar.Collapse id="navbar-toggle">
                    <Nav  className="ml-auto">
                      <Link style={{color: 'goldenrod'}} className="nav-link" to="/">Home</Link>
                      <Link style={{color: 'goldenrod'}} className="nav-link" to="/about">About</Link>
                      <Link style={{color: 'goldenrod'}} className="nav-link" to="/contact">Contact</Link>
                      <Link style={{color: 'goldenrod'}} className="nav-link" to="/gallery">Gallery</Link>
                      <Link style={{color: 'goldenrod'}} className="nav-link" to="/CoverLetter">Cover Letter</Link>
                      <Link style={{color: 'goldenrod'}} className="nav-link" to="/Resume">Resume</Link>


                    </Nav>

                  </Navbar.Collapse>

                  </Navbar>
                  <Route path="/" exact render={() => <HomePage title={this.state.home.title} subTitle={this.state.home.subTitle} text={this.state.home.text} />}/>
                  <Route path="/about" render={() => <AboutPage title={this.state.about} />}/>
                  <Route path="/contact" render={() => <ContactPage title={this.state.contact} />}/>
                  <Route path="/Adventure" render={() => <Adventure title={this.state.Adventure} />}/>
                  <Route path="/sidescroller" render={() => <Sidescroller title={this.state.sidescroller} />}/>
                  <Route path="/thereturn" exact render={() => <Thereturn title={this.state.thereturn} />}/>
                  <Route path="/gallery" render={() => <Gallery title={this.state.gallery} />}/>
                  <Route path='/CoverLetter' component={() => {window.location.href = 'https://1drv.ms/b/s!AmeURvO0TT16g5onw80N4mky462qAw?e=I46pLd'}}/>
                  <Route path='/Resume' component={() => {window.location.href = 'https://1drv.ms/b/s!AmeURvO0TT16g5oom0FsKOCwNhD_lQ?e=Zj6GPR'}}/>
                  <Footer />
              </Container>



        </Router>
      );
    }
  };



export default App;
